import React from "react";
import "./footer.css";
const Footer = () => {
  return (
    // <div 
    // style={{
    //   display: "flex",
    //   alignItems: "center",
    //   justifyContent: "center",
    //   color: "#000000",
    //   fontWeight: "bold",
    //   marginTop: "0",
    //   background: "none",
    // }}
    // >
    //   <p>All Right Reserved &copy;MERINASOFT</p>
    // </div>
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#ffffff",
    fontWeight: "600",
    fontSize: "14px",
    padding: "15px 0",
    backgroundColor: "transparent", // ✅ real transparency
    letterSpacing: "1px",
    textShadow: "0 1px 2px rgba(0,0,0,0.4)",
    transition: "color 0.3s ease",
    cursor: "default",
    position: "relative",
    zIndex: 10, // make sure it's above blur layer
  }}
  onMouseEnter={(e) => (e.currentTarget.style.color = "#ffb6c1")}
  onMouseLeave={(e) => (e.currentTarget.style.color = "#ffffff")}
>
  <p style={{ margin: 0 }}>All Rights Reserved © MERINASOFT</p>
</div>

  );



};

export default Footer;
